/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Negotiation_Page_DescriptionInputs */

const en_negotiation_page_description = /** @type {(inputs: Negotiation_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready-to-use salary negotiation scripts with DACH-specific advice. Select a scenario to get started.`)
};

const de_negotiation_page_description = /** @type {(inputs: Negotiation_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready-to-use salary negotiation scripts with DACH-specific advice. Select a scenario to get started.`)
};

const fr_negotiation_page_description = /** @type {(inputs: Negotiation_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready-to-use salary negotiation scripts with DACH-specific advice. Select a scenario to get started.`)
};

const es_negotiation_page_description = /** @type {(inputs: Negotiation_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready-to-use salary negotiation scripts with DACH-specific advice. Select a scenario to get started.`)
};

const it_negotiation_page_description = /** @type {(inputs: Negotiation_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready-to-use salary negotiation scripts with DACH-specific advice. Select a scenario to get started.`)
};

const nl_negotiation_page_description = /** @type {(inputs: Negotiation_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready-to-use salary negotiation scripts with DACH-specific advice. Select a scenario to get started.`)
};

const pl_negotiation_page_description = /** @type {(inputs: Negotiation_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready-to-use salary negotiation scripts with DACH-specific advice. Select a scenario to get started.`)
};

const fi_negotiation_page_description = /** @type {(inputs: Negotiation_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready-to-use salary negotiation scripts with DACH-specific advice. Select a scenario to get started.`)
};

const da_negotiation_page_description = /** @type {(inputs: Negotiation_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready-to-use salary negotiation scripts with DACH-specific advice. Select a scenario to get started.`)
};

const sv_negotiation_page_description = /** @type {(inputs: Negotiation_Page_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready-to-use salary negotiation scripts with DACH-specific advice. Select a scenario to get started.`)
};

/**
* | output |
* | --- |
* | "Ready-to-use salary negotiation scripts with DACH-specific advice. Select a scenario to get started." |
*
* @param {Negotiation_Page_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const negotiation_page_description = /** @type {((inputs?: Negotiation_Page_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Negotiation_Page_DescriptionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_negotiation_page_description(inputs)
	if (locale === "fr") return fr_negotiation_page_description(inputs)
	if (locale === "es") return es_negotiation_page_description(inputs)
	if (locale === "it") return it_negotiation_page_description(inputs)
	if (locale === "nl") return nl_negotiation_page_description(inputs)
	if (locale === "pl") return pl_negotiation_page_description(inputs)
	if (locale === "fi") return fi_negotiation_page_description(inputs)
	if (locale === "da") return da_negotiation_page_description(inputs)
	if (locale === "sv") return sv_negotiation_page_description(inputs)
	return en_negotiation_page_description(inputs)
});